// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VbNh","col":"styles_col__3-kWw"};